import { isPlainObject } from 'is-plain-object';

import { Block, type BlockCreateProps } from './block';
import { Data } from './data';
import type { FragmentMap } from './fragment';
import { Inline, type InlineCreateProps } from './inline';

/*
 * Create a dictionary of settable node properties from `attrs`.
 */
export function createNodeProperties(attrs: BlockCreateProps | InlineCreateProps = {}): {
    key?: string;
    data?: Data;
    fragments?: FragmentMap;
    isVoid?: boolean;
    type?: string;
} {
    if (Block.isBlock(attrs) || Inline.isInline(attrs)) {
        return {
            key: attrs.key,
            data: attrs.data,
            fragments: attrs.fragments,
            isVoid: attrs.isVoid,
            type: attrs.type,
        };
    }

    if (typeof attrs === 'string') {
        return { type: attrs };
    }

    if (isPlainObject(attrs)) {
        const props: {
            key?: string;
            data?: Data;
            fragments?: FragmentMap;
            isVoid?: boolean;
            type?: string;
        } = {};
        if ('key' in attrs) {
            props.key = attrs.key;
        }
        if ('type' in attrs) {
            props.type = attrs.type;
        }
        if ('data' in attrs) {
            props.data = Data.create(attrs.data);
        }
        if ('isVoid' in attrs) {
            props.isVoid = attrs.isVoid;
        }
        if ('fragments' in attrs) {
            props.fragments = attrs.fragments as FragmentMap;
        }
        return props;
    }

    throw new Error(
        `\`Node.createProperties\` only accepts objects, strings, blocks or inlines, but you passed it: ${attrs}`
    );
}
